<template>
  <Dropdown
    v-model="selected"
    :options="options"
    :option-label="(value) => value.toUpperCase()"
    :unselectable="false"
    @change="handleChange"
  />
</template>

<script>

import Dropdown from "primevue/dropdown";

export default {
  name: 'LocaleChooserComponent',
  components: {Dropdown},
  data() {
    return {
      selected: this.$i18n.locale,
      options: [
        'fr',
        'en'
      ]
    }
  },
  mounted() {
    this.handleChange()
  },
  methods: {
    handleChange(){
      this.$store.dispatch('i18n/changeLocal', {locale: this.selected, primevue: this.$primevue});
    }
  }
}
</script>
